<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.profile') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <!-- <el-button
          class="common-btn mb-30"
          @click="openCreateOrganisationDialog"
          v-if="p('Organisations.Add')"
          >{{ $t('text.create_organisation') }}</el-button
        > -->
        <el-form
          :model="form"
          :rules="rules"
          label-position="left"
          label-width="100px"
          ref="form"
          v-loading="fetchOrganisationDetailLoading"
        >
          <el-form-item :label="$t('text.name')" prop="OrganisationName">
            <el-input
              v-model="form.OrganisationName"
              :placeholder="$t('text.name')"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('text.address')" prop="OrganisationAddress">
            <el-input
              v-model="form.OrganisationAddress"
              :placeholder="$t('text.address')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('text.phone')" prop="OrganisationContact">
            <el-input
              v-model="form.OrganisationContact"
              :placeholder="$t('text.phone')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('text.location')" prop="Location">
            <el-select
              v-model="form.Location"
              filterable
              :placeholder="$t('text.location')"
              class="wp-100"
              disabled
            >
              <el-option
                v-for="item in countryList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.time_zone')" prop="TimeZone">
            <el-select
              v-model="form.TimeZone"
              filterable
              :placeholder="$t('text.time_zone')"
              class="wp-100"
              :loading="fetchTimezoneLoading"
              disabled
            >
              <el-option
                v-for="item in timeZoneList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="IsDemo"
            v-if="p('Organisations.Edit') || p('Organisations.Add')"
          >
            <el-checkbox v-model="form.IsDemo">{{
              $t('text.demo_org_desc')
            }}</el-checkbox>
          </el-form-item>
          <el-form-item class="mt-30">
            <el-button
              class="common-btn min-w-80"
              :loading="loading"
              @click="submit()"
              size="medium"
              v-if="p('Organisations.Edit')"
              >{{ $t('text.save').toUpperCase() }}</el-button
            >
            <el-button
              class="cancel-btn min-w-80"
              @click="resetForm()"
              size="medium"
              >{{ $t('text.reset') }}</el-button
            >
          </el-form-item>
        </el-form>
        <CreateOrganisationDialog ref="createOrganisationDialog" />
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
import countries from 'countries-list'
import CreateOrganisationDialog from '@/components/manage/organisation/CreateOrganisationDialog.vue'
export default {
  data() {
    return {
      loading: false,
      fetchTimezoneLoading: false,
      fetchOrganisationDetailLoading: false,
      timeZoneList: [],
      countryList: [],
      organisationDetail: {},
      form: {
        OrganisationId: '',
        OrganisationName: '',
        OrganisationAddress: '',
        OrganisationContact: '',
        Location: '',
        TimeZone: '',
        IsDemo: false
      },
      rules: {
        OrganisationAddress: [
          {
            required: true,
            message: this.$t('text.please_enter_organisation_address'),
            trigger: 'blur'
          }
        ],
        OrganisationContact: [
          {
            required: true,
            message: this.$t('text.please_enter_organisation_phone'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    CreateOrganisationDialog
  },
  mounted() {
    this.getAllLocation()
    this.getCountryList()
    this.getOrganisationDetail()
  },
  methods: {
    openCreateOrganisationDialog() {
      this.$refs.createOrganisationDialog.openDialog()
    },
    getOrganisationDetail() {
      this.fetchOrganisationDetailLoading = true
      ApiService.GetOrganisationDetail(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.fetchOrganisationDetailLoading = false
          if (response.data.success) {
            this.organisationDetail = response.data.data
            this.setForm()

            // Make the IsDemo property take effect immediately after modification
            let user = localStorage.getItem('user')
              ? JSON.parse(localStorage.getItem('user'))
              : false
            user.organisations = user.organisations.map(item => {
              return {
                ...item,
                OrganisationName: {
                  ...item.OrganisationName,
                  IsDemo:
                    item.OrganisationName.OrganisationId ===
                    this.organisationDetail.OrganisationId
                      ? this.organisationDetail.IsDemo
                      : item.OrganisationName.IsDemo
                }
              }
            })
            this.$store.commit('user/SET_USER_DATA', user)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.fetchOrganisationDetailLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    setForm() {
      this.form = {
        OrganisationId: this.organisationDetail.OrganisationId,
        OrganisationName: this.organisationDetail.Name,
        OrganisationAddress: this.organisationDetail.Address,
        OrganisationContact: this.organisationDetail.ContactNumber,
        Location: this.organisationDetail.Location,
        TimeZone: this.organisationDetail.TimeZone,
        IsDemo: this.organisationDetail.IsDemo
      }
    },
    getCountryList() {
      const countryCodes = Object.keys(countries.countries)
      this.countryList = countryCodes.map(
        code => countries.countries[code].name
      )
    },
    getAllLocation() {
      this.fetchTimezoneLoading = true
      ApiService.GetAllLocation()
        .then(response => {
          this.fetchTimezoneLoading = false
          this.timeZoneList = response.data.data
        })
        .catch(() => {
          this.fetchTimezoneLoading = false
        })
    },
    resetForm() {
      this.setForm()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveOrganisation()
        }
      })
    },
    saveOrganisation() {
      this.loading = true
      ApiService.SaveOrganisation({
        ...this.form,
        DomainName: document.domain
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getOrganisationDetail()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
